<template>
    <div class="yes-no-any-input">
        <div class="yes-no-any-input__title">
            {{ title }}
        </div>
        <div class="yes-no-any-input__block">
            <div class="yes-no-any-input__radio-wrapper">
                <label>
                    <input
                        type="radio"
                        :value="yesValue"
                        :checked="value === yesValue"
                        v-on:input="$emit('input', yesValue)"
                    />
                    <span>{{ yesLabel }}</span>
                </label>
            </div>
            <div class="yes-no-any-input__radio-wrapper">
                <label>
                    <input
                        type="radio"
                        :value="noValue"
                        :checked="value === noValue"
                        v-on:input="$emit('input', noValue)"
                    />
                    <span>{{ noLabel }}</span>
                </label>
            </div>
        </div>
        <div class="yes-no-any-input__block yes-no-any-input__block--any">
            <div class="yes-no-any-input__radio-wrapper">
                <label>
                    <input
                        type="radio"
                        value=""
                        :checked="value === '' || value === null || value === undefined"
                        v-on:input="$emit('input', anyValue)"
                    />
                    <span>{{ anyLabel }}</span>
                </label>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    emits: ['input'],
    props: {
        value: {
            required: true,
        },
        title: {
            type: String,
            required: true,
        },
        yesLabel: {
            type: String,
            default: () => 'Да',
        },
        yesValue: {
            default: () => "true",
        },
        noLabel: {
            type: String,
            default: () => 'Нет',
        },
        noValue: {
            default: () => "false",
        },
        anyLabel: {
            type: String,
            default: () => 'Не имеет значения',
        },
        anyValue: {
            default: () => null,
        },
    },
};
</script>

<style lang="scss" scoped>
@import "~@/styles/rem";
@import "~@/styles/variables";

.yes-no-any-input {
    &__title {
        color: $color-black-text;
        font-style: normal;
        font-weight: 600;
        margin: 0 0 mrem(16) 0;
        font-size: mrem(18);
        line-height: mrem(26);

        @include on-desktop {
            margin: 0 0 rem(16) 0;
            font-size: rem(18);
            line-height: rem(26);
        }
    }

    &__block {
        display: flex;
        gap: mrem(40);

        @include on-desktop {
            gap: rem(40);
        }

        &--any {
            margin-top: mrem(16);

            @include on-desktop {
                margin-top: rem(16);
            }
        }
    }

    &__radio-wrapper {
        display: flex;
        align-items: center;
    }

    input[type="radio"] {
        cursor: pointer;
        width: mrem(20);
        height: mrem(20);
        margin: 0 mrem(6) 0 0;
        accent-color: $color-main-blue;

        @include on-desktop {
            width: rem(20);
            height: rem(20);
            margin: 0 rem(6) 0 0;
        }
    }

    label {
        cursor: pointer;
        color: $color-black-text;
        font-family: $font-montserrat;
        font-style: normal;
        font-weight: 400;
        font-size: mrem(18);
        line-height: mrem(26);

        display: flex;
        align-items: center;

        @include on-desktop {
            font-size: rem(18);
            line-height: rem(26);
        }
    }
}
</style>
